import { useEffect } from 'react';

const usePersonalization = (personalization) => {
  useEffect(() => {
    if (personalization) {
      personalization?.data?.forEach((entry) => {
        const element = document.getElementById(entry.id);
        if (element) {
          if (entry.source) {
            element.src = entry.source;
            element.srcset = '';
          } else if (entry.style) {
            element.style = entry.style;
          } else {
            element.innerText = entry.value;
          }
        }
      });
    }
  }, [personalization]);
};

export default usePersonalization;
